<template>
  <div class="lists list-light texture-light-bg-css">
    <div class="w">
      <div class="page-header"><Breadcrumb class="deep-breadcrumb" /></div>
      <div>
        <div class="text-center content-title">
          <span class="inline-block title-font">{{ fontTitle }}</span>
        </div>
        <div class="text-center">
          <ul
            v-if="listData && listData.data && listData.data.length !== 0"
            class="text-center lists-content light-flower-bg"
          >
            <li
              v-for="list in listData.data"
              :key="list.id"
              @click="
                link(
                  {
                    type: 'info',
                    link: '/info',
                    category: list.category_id,
                    id: list.id
                  },
                  'windowOpen'
                )
              "
              :class="list.ontop && list.ontop === 1 ? 'on-top' : ''"
            >
              <i class="s-flower"></i>
              <span class="al-content"> {{ list.title || '暂无数据' }} </span>
              <span class="float-right">{{
                list.published_at ? dateFilter(list.published_at) : ''
              }}</span>
            </li>
          </ul>
          <div v-else class="text-center lists-content light-flower-bg no-data">
            暂无数据
          </div>
          <div class="pag text-center">
            <paginate
              class="clearfix deep-page"
              v-model="listData.page"
              :page-count="listData.pageCount"
              :page-range="3"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="''"
              :next-text="''"
              prev-class="page-prev"
              next-class="page-next"
              :container-class="'pagination'"
              :page-class="'page-item'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import link from '@/core/mixins/link'
import Breadcrumb from '@/components/common/Breadcrumb'
import dateFilter from '@/core/mixins/dateFilter'
import { getArticles } from '@/core/api'
export default {
  name: 'announcement',
  mixins: [dateFilter, link],
  components: {
    Breadcrumb
  },
  data() {
    return {
      listData: {
        data: [],
        total: 0, // 总数
        page: 1, // 第几页
        pageSize: 10, //每页条数
        pageCount: 0
      },
      category: null
    }
  },
  watch: {
    '$route.fullPath'() {
      this.getListData()
    }
  },
  computed: {
    fontTitle() {
      let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
      let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
        category
      )
      return breadcrumb[breadcrumb.length - 1].title
    }
  },
  mounted: function() {
    this.getListData()
    scrollTo(0, 0)
  },
  methods: {
    clickCallback(pageNum) {
      document.body.scrollIntoView()
      this.listData.page = pageNum
      this.getListData()
    },
    async getListData() {
      this.category = this.$route.params.category // 从地址栏拿栏目的ID
      let data = {
        page: this.listData.page,
        pageSize: this.listData.pageSize
      }
      let res = await getArticles(this.category, data)
      // console.log({ data, res }) // eslint-disable-line no-console
      if (res.status === 200) {
        this.listData.total = res.data.total
        this.listData.data = res.data.data
      }
      this.listData.pageCount = Math.ceil(
        this.listData.total / this.listData.pageSize
      )
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.no-data {
  color: $c-tour-0;
}
.lists-content {
  > li {
    position: relative;
    padding-left: 36px !important;
    .s-flower {
      position: absolute;
      top: 32px;
      left: 0;
    }
  }
}
</style>
